<template>
    <div>
        <label v-show="hasLabel" :for="id" class="block text-sm font-medium text-gray-700">{{ label }}<span v-show="required" class="text-teal font-bold">*</span></label>
        <div class="relative" :class="{
            'mt-1': hasLabel
        }">
            <Datepicker v-model="dateValue" :inputFormat="inputFormat" class="shadow-sm focus:ring-teal focus:border-teal block w-full sm:text-sm border-gray-200 rounded-md" />
        </div>
    </div>
</template>

<script>
import Datepicker from 'vue3-datepicker'
import { ref, watch } from 'vue'

export default {
    components: {
        Datepicker
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default(){
                return 'date-field-' + Math.random().toString(36).substr(2, 9);
            }
        },
        name: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        inputFormat: {
            type: String,
            default: 'MM-dd-yyyy'
        },
        modelValue: {
            type: String,
            default: new Date()
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }){
        const dateValue = ref(moment(props.modelValue, 'MM-DD-YYYY').toDate());

        watch(dateValue, (value) => {
            emit('update:modelValue', moment(value).format('MM-DD-YYYY'));
        });

        return {
            dateValue
        }
    },
    computed: {
        hasLabel(){
            return this.label != '';
        },
    }
}
</script>

<style>

</style>